export const APP_INTEGRATION_FEATURE_SWITCH = "FS-app-integration" as const;
